class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notificationEle = document.querySelector('cart-notification');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);


    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close, .cart-notification__links .button-label').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', this.handleCartAction.bind(this));
  }

  open() {
    this.notificationEle.classList.add('active');
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('nfw-cart-open');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notificationEle.classList.remove('active');
    this.notification.classList.remove('active');
    document.body.classList.remove('nfw-cart-open');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  handleCartAction(evt) {
    const control = evt.target.closest('[data-nfw-cart-action]');
    if (!control || !this.contains(control)) return;

    evt.preventDefault();

    const action = control.getAttribute('data-nfw-cart-action');
    const line = Number(control.dataset.line);
    const currentQuantity = Number(control.dataset.quantity);

    if (!line || Number.isNaN(currentQuantity)) return;

    let quantity = currentQuantity;

    if (action === 'increase') quantity = currentQuantity + 1;
    if (action === 'decrease') quantity = Math.max(currentQuantity - 1, 0);
    if (action === 'remove') quantity = 0;

    if (quantity === currentQuantity) return;

    this.updateLine(line, quantity);
  }

  updateLine(line, quantity) {
    const errorElement = this.querySelector('.nfw-cart-drawer__error');
    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    this.notification.classList.add('nfw-cart-updating');
    this.notification.setAttribute('aria-busy', 'true');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.status || parsedState.errors) {
          throw new Error(parsedState.description || window.cartStrings.error);
        }

        this.getSectionsToRender().forEach((section) => {
          if (!parsedState.sections || !parsedState.sections[section.id]) return;

          const target = document.getElementById(section.id);
          if (!target) return;

          target.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        });
      })
      .catch((error) => {
        const currentErrorElement = this.querySelector('.nfw-cart-drawer__error');
        if (currentErrorElement) {
          currentErrorElement.textContent = error.message || window.cartStrings.error;
          currentErrorElement.hidden = false;
        }
      })
      .finally(() => {
        this.notification.classList.remove('nfw-cart-updating');
        this.notification.removeAttribute('aria-busy');
      });
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
